const ROUND_CONSTANTS = new Uint32Array([
  0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
  0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
  0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
  0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
  0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
  0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
  0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
  0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208, 0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2,
]);

function rotateRight(value: number, count: number): number {
  return (value >>> count) | (value << (32 - count));
}

function compress(bytes: Uint8Array, offset: number, words: Uint32Array, state: Uint32Array): void {
  for (let i = 0; i < 16; i++) {
    const at = offset + 4 * i;
    words[i] = (bytes[at]! << 24) | (bytes[at + 1]! << 16) | (bytes[at + 2]! << 8) | bytes[at + 3]!;
  }
  for (let i = 16; i < 64; i++) {
    const a = words[i - 15]!,
      b = words[i - 2]!;
    const s0 = rotateRight(a, 7) ^ rotateRight(a, 18) ^ (a >>> 3);
    const s1 = rotateRight(b, 17) ^ rotateRight(b, 19) ^ (b >>> 10);
    words[i] = (words[i - 16]! + s0 + words[i - 7]! + s1) >>> 0;
  }
  let a = state[0]!,
    b = state[1]!,
    c = state[2]!,
    d = state[3]!;
  let e = state[4]!,
    f = state[5]!,
    g = state[6]!,
    h = state[7]!;
  for (let i = 0; i < 64; i++) {
    const s1 = rotateRight(e, 6) ^ rotateRight(e, 11) ^ rotateRight(e, 25);
    const choose = (e & f) ^ (~e & g);
    const t1 = (h + s1 + choose + ROUND_CONSTANTS[i]! + words[i]!) >>> 0;
    const s0 = rotateRight(a, 2) ^ rotateRight(a, 13) ^ rotateRight(a, 22);
    const majority = (a & b) ^ (a & c) ^ (b & c);
    const t2 = (s0 + majority) >>> 0;
    h = g;
    g = f;
    f = e;
    e = (d + t1) >>> 0;
    d = c;
    c = b;
    b = a;
    a = (t1 + t2) >>> 0;
  }
  const result = [a, b, c, d, e, f, g, h];
  for (let i = 0; i < 8; i++) state[i] = (state[i]! + result[i]!) >>> 0;
}

/** SHA-256 of the exact supplied bytes, for cache checksums when Web Crypto is unavailable. */
export function sha256Hex(bytes: Uint8Array): string {
  const state = new Uint32Array([
    0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a, 0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19,
  ]);
  const words = new Uint32Array(64);
  const remainder = bytes.length % 64;
  const complete = bytes.length - remainder;
  for (let offset = 0; offset < complete; offset += 64) compress(bytes, offset, words, state);
  const tail = new Uint8Array(remainder < 56 ? 64 : 128);
  tail.set(bytes.subarray(complete));
  tail[remainder] = 0x80;
  const length = new DataView(tail.buffer);
  length.setUint32(tail.length - 8, Math.floor(bytes.length / 0x20000000));
  length.setUint32(tail.length - 4, (bytes.length * 8) >>> 0);
  for (let offset = 0; offset < tail.length; offset += 64) compress(tail, offset, words, state);
  return [...state].map((word) => word.toString(16).padStart(8, '0')).join('');
}
